export function initFlipbook() {
  const roots = Array.from(document.querySelectorAll("[data-flipbook]"));
  if (!roots.length) return;

  const load = (root) => {
    import("./flipbookReader")
      .then(({ mountFlipbook }) => mountFlipbook(root))
      .catch(() => {
        const loader = root.querySelector("[data-flipbook-loader]");
        if (loader) {
          loader.textContent =
            "Nie udalo sie wczytac gazetki. Skorzystaj z linku do pliku PDF ponizej.";
        }
      });
  };

  if (!("IntersectionObserver" in window)) {
    roots.forEach(load);
    return;
  }

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          observer.unobserve(entry.target);
          load(entry.target);
        }
      });
    },
    { rootMargin: "400px 0px" }
  );

  roots.forEach((root) => observer.observe(root));
}
